export default __webpack_public_path__ + "static/media/promise-card-logo.f5ceb42f.svg";